var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{attrs:{"tag":_vm.row.key()}},[_c('Column',{attrs:{"width":13}}),_c('Column',{attrs:{"width":2}},[_vm._v(" "+_vm._s(_vm.ContentUtils.decode(_vm.row.name()))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }